import React from 'react';

const Skeleton = ({ 
  className = '', 
  variant = 'text', 
  width = '100%', 
  height = '1rem',
  lines = 1,
  rounded = true
}) => {
  const baseClasses = `bg-background animate-pulse ${
    rounded ? 'rounded' : ''
  }`;

  if (variant === 'text') {
    if (lines === 1) {
      return (
        <div
          className={`${baseClasses} ${className}`}
          style={{ width, height }}
        />
      );
    }

    return (
      <div className={className}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={`${baseClasses} mb-2`}
            style={{ 
              width: index === lines - 1 ? '75%' : '100%', 
              height 
            }}
          />
        ))}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className={`${baseClasses} p-6 ${className}`}>
        <div className="space-y-4">
          <div className="h-4 bg-gray-300 rounded w-3/4" />
          <div className="space-y-2">
            <div className="h-3 bg-gray-300 rounded w-full" />
            <div className="h-3 bg-gray-300 rounded w-5/6" />
            <div className="h-3 bg-gray-300 rounded w-4/6" />
          </div>
          <div className="flex space-x-2">
            <div className="h-8 bg-gray-300 rounded w-20" />
            <div className="h-8 bg-gray-300 rounded w-24" />
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'image') {
    return (
      <div
        className={`${baseClasses} ${className}`}
        style={{ width, height }}
      />
    );
  }

  if (variant === 'button') {
    return (
      <div
        className={`${baseClasses} h-10 ${className}`}
        style={{ width }}
      />
    );
  }

  if (variant === 'avatar') {
    return (
      <div
        className={`${baseClasses} rounded-full ${className}`}
        style={{ width, height }}
      />
    );
  }

  return (
    <div
      className={`${baseClasses} ${className}`}
      style={{ width, height }}
    />
  );
};

export default Skeleton;

